import React from 'react'
import { DateRangeFilter } from '../DateRangeFilter'

export const QuestionnaireDateRangeFilter = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return <DateRangeFilter title="Due Date" isNested={isNested} />
  },
)
